import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = "Resume Architect - Free AI Resume Builder";
    const defaultDescription = "Build a professional resume in minutes with AI. Free templates, ATS-friendly formats, and instant job matching.";
    const defaultKeywords = "resume builder, AI resume, free resume templates, CV maker, ATS resume, job finder";
    const siteUrl = "https://resumearchitect.pro";
    const defaultImage = `${siteUrl}/og-image.jpg`; // Ensure you have an og-image.jpg in public folder or use logo

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title ? `${title} | Resume Architect` : siteTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || siteUrl} />
            <meta property="og:title" content={title || siteTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url || siteUrl} />
            <meta name="twitter:title" content={title || siteTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={image || defaultImage} />
        </Helmet>
    );
};

export default SEO;
